import './App.css';
import PupRoutes from './routes/PupRoutes';
import AuthState from "./context/AuthState";
import NavState from "./context/NavState";

function App() {
    return (

      <AuthState>
          <NavState>
            <PupRoutes/>
          </NavState>
      </AuthState>
         );
  
}

export default App;
